
import React from 'react';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./components/Auth/AuthProvider";
import { TwoFactorAuthProvider } from "./components/Auth/TwoFactorAuthProvider";
import { AuthenticationFlow } from "./components/Auth/AuthenticationFlow";
import { AuthPage } from "./components/Auth/AuthPage";
import { ProtectedRoute } from "./components/Layout/ProtectedRoute";
import { MainLayout } from "./components/Layout/MainLayout";
import { DashboardOverview } from "./components/Dashboard/DashboardOverview";
import { RiskManagementMain } from "./components/RiskManagement/RiskManagementMain";
import { CarbonAccountingMain } from "./components/CarbonAccounting/CarbonAccountingMain";
import { PortfolioMain } from "./components/Portfolio/PortfolioMain";
import { NetZeroMain } from "./components/NetZero/NetZeroMain";
import { SupplyChainMain } from "./components/SupplyChain/SupplyChainMain";
import { MaterialityAssessmentMain } from "./components/MaterialityAssessment/MaterialityAssessmentMain";
import { ClimateRiskMain } from "./components/ClimateRisk/ClimateRiskMain";
import DataManagement from "./pages/DataManagement";
import ESGReporting from "./pages/ESGReporting";
import NotFound from "./pages/NotFound";
import { SettingsMain } from "./components/Settings/SettingsMain";
import { ResetPasswordPage } from './components/Auth/ResetPasswordPage';
import { VerifyEmailPage } from './components/Auth/VerifyEmailPage';
import { EmailDebugPage } from './components/Auth/EmailDebugPage';
import { ResendVerificationPage } from './components/Auth/ResendVerificationPage';

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <TwoFactorAuthProvider>
          <AuthenticationFlow>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/resend-verification" element={<ResendVerificationPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/email-debug" element={<EmailDebugPage />} />
            <Route path="/" element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }>
              <Route index element={<DashboardOverview />} />
              <Route path="/data-management" element={<DataManagement />} />
              <Route path="/reporting" element={<ESGReporting />} />
              <Route path="/risk-management" element={
                <div className="p-6">
                  <RiskManagementMain />
                </div>
              } />
              <Route path="/carbon-accounting" element={
                <div className="p-6">
                  <CarbonAccountingMain />
                </div>
              } />
              <Route path="/portfolio" element={
                <div className="p-6">
                  <PortfolioMain />
                </div>
              } />
              <Route path="/net-zero" element={
                <div className="p-6">
                  <NetZeroMain />
                </div>
              } />
              <Route path="/supply-chain" element={
                <div className="p-6">
                  <SupplyChainMain />
                </div>
              } />
              <Route path="/materiality-assessment" element={
                <div className="p-6">
                  <MaterialityAssessmentMain />
                </div>
              } />
              <Route path="/climate-risk" element={
                <div className="p-6">
                  <ClimateRiskMain />
                </div>
              } />
              <Route path="/settings" element={
                <div className="p-6">
                  <SettingsMain />
                </div>
              } />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
          </AuthenticationFlow>
        </TwoFactorAuthProvider>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
